import React from 'react';
import { IonContent, IonInfiniteScroll, IonInfiniteScrollContent, IonPage, IonRefresher, IonRefresherContent } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { Tabs } from 'antd';
import { Empty, Header, NotificationAudio, OrderCard } from 'components';
import { axius, env, func, types } from 'utils';
import OneSignal from 'onesignal-cordova-plugin';

import './_styles.scss';

const limit = 6;
const statuses = {
    new: [types.OrderStatus.NEW, types.OrderStatus.ACCEPTED, types.OrderStatus.PREPARING, types.OrderStatus.READY],
    ongoing: [types.OrderStatus.DELIVERY, types.OrderStatus.ARRIVED],
    past: [types.OrderStatus.CANCELLED, types.OrderStatus.COMPLETED, types.OrderStatus.UNCLAIMED],
};
let refresher: any = null;
let infinitScroller: any = null;

interface Props extends RouteComponentProps, types.StateProps { };
const Orders: React.FC<Props> = props => {

    const { _auth: { user } } = props;

    const [tab, setTab] = React.useState(Object.keys(statuses)[0]);
    const [step, setStep] = React.useState(1);
    const [data, setData] = React.useState([]);
    const [total, setTotal] = React.useState(0);
    const [played, setPlayed] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        getData(1);
        newOrderslistener();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (tab) {
            getData(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab]);

    // React.useEffect(() => {
    //     getData();
    //     let orderTimer = setInterval(() => {
    //         getData(step);
    //     }, 5000);
    //     return () => {
    //         clearInterval(orderTimer);
    //     };
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [step]);

    const getData = (stap: number = step) => {
        setStep(stap);
        !infinitScroller && setLoading(true);
        axius.get(`orders`, {
            cursor: `${((stap - 1) * limit)}-${limit}`,
            status: statuses[tab as keyof typeof statuses].join(),
        }).then((res: types.AxiusResponse) => {
            setTotal(res.status === 200 ? res.meta.total : 0);
            if (res.status === 200) {
                if (stap > 1) {
                    let newData = JSON.parse(JSON.stringify(data));
                    newData = newData.concat(res.data);
                    setData(newData);
                } else {
                    setData(res.data);
                }
            } else {
                stap === 1 && setData([]);
            }
            setLoading(false);
            refresher && refresher.detail.complete();
            infinitScroller && infinitScroller.target.complete();
        });
    }

    const newOrderslistener = async () => {
        if (func.isMobile) {
            OneSignal.setNotificationWillShowInForegroundHandler(async (notificationReceivedEvent) => {
                let notification = notificationReceivedEvent.getNotification();
                if (notification.body.toLocaleLowerCase().includes('assigned to you')) {
                    setTimeout(async () => {
                        getData(1);
                        func.vibrate();
                        func.playNotificationSound(4000).then(e => {
                            setPlayed(e);
                        });
                    }, 500);
                }
            });
            OneSignal.setNotificationOpenedHandler(async (notificationOpenedEvent) => {
                if (notificationOpenedEvent.notification.body.toLocaleLowerCase().includes('assigned to you')) {
                    setTab('new');
                    setTimeout(async () => {
                        getData(1);
                    }, 500);
                }
            });
        } else {
            const sse = new EventSource(`${env.API_URL}sse?key=${user.id}`);
            sse.onmessage = (event) => {
                const sseOrder = func.isJson(event.data) ? JSON.parse(event.data) : {};
                // Only play sound alert for venues user has access to
                if (sseOrder.merchant === 'CR' && sseOrder.type === 'NEW_ORDER') {
                    setTab('new');
                    setTimeout(async () => {
                        getData(1);
                        func.vibrate();
                        func.playNotificationSound(4000).then(e => {
                            setPlayed(e);
                        });
                    }, 500);
                }
            }
        }
    }

    return (
        <IonPage id="Orders">
            <Header {...props} title="Deliveries" />

            <IonContent fullscreen={false}>
                <IonRefresher slot="fixed" onIonRefresh={(e) => {
                    refresher = e;
                    getData(1);
                }}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <div className="px-4 bg-whites">
                    <Tabs
                        type="line"
                        centered={true}
                        activeKey={tab}
                        items={Object.keys(statuses).map(key => {
                            return {
                                key,
                                label: `${func.ucWords(key)} Orders`,
                            };
                        })}
                        onChange={setTab}
                    />
                </div>

                <div className="px-4 mt-3">
                    {loading && [...Array(5)].map((_, i) => (
                        <div className="px-4s" key={i}>
                            <div className="skeleton mb-3" style={{ height: 287.5, borderRadius: 7 }} />
                        </div>
                    ))}

                    {!loading && data.length === 0 && (
                        <Empty style={{}} text="No orders yet" subText="Orders will appear here once received" />
                    )}

                    {!loading && data.length > 0 && data.map((row: types.Order, i: number) => (
                        <OrderCard key={`${i}_${row.uuid}`} {...props} row={row} />
                    ))}

                    {!loading && total > limit && (
                        <IonInfiniteScroll
                            onIonInfinite={(e) => {
                                infinitScroller = e;
                                getData(step + 1);
                            }}
                        >
                            <IonInfiniteScrollContent></IonInfiniteScrollContent>
                        </IonInfiniteScroll>
                    )}
                </div>
                <NotificationAudio open={!played} />
            </IonContent>
        </IonPage>
    );
}

export default Orders;